module.exports = __webpack_public_path__ + "static/media/mc_controls_panel.82f98a6c.svg";